import { GOOGLE_MAP_API_KEY } from '../constants'
import { useState, useEffect } from 'react'
import Geocode from 'react-geocode'

type LongLat = { lat: number; long: number; address: string }
const useFindLatLong = (addresses: string[] = ['Area 51, NV, USA']): LongLat[] => {
  Geocode.setApiKey(GOOGLE_MAP_API_KEY) //Insert your Google Maps API here
  Geocode.enableDebug()

  const [latLong, setLatLong] = useState<LongLat[]>([])
  useEffect(() => {
    addresses.forEach((address) => {
      Geocode.fromAddress(address).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location
          setLatLong((prev) => [...prev, { lat, long: lng, address }])
        },
        (error) => {
          console.error(error)
        }
      )
    })
  }, [addresses])

  return latLong
}

export default useFindLatLong
